import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import {
  Add_Channal,
  delete_Channal,
  Get_Error,
  get_one_channal,
  GetAll_Channal,
  update_one_channal,
} from '../Types';
import usegetdata from '../../Hooks/useGetData';
import usedeletedata from '../../Hooks/useDeleteData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';

//add all cities data
export const Add_Channal_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/channal`, body);

    dispatch({
      type: Add_Channal,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all cities data
export const GetAllchannalData = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/channal?active=true`);

    dispatch({
      type: GetAll_Channal,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const GetAllchannalDataTrash = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/channal?active=false`);

    dispatch({
      type: GetAll_Channal,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one city data
export const DeleteOnechannalData = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/channal/${id}`);

    dispatch({
      type: delete_Channal,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one city data
export const GetOnechannalData = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/channal/${id}`);

    dispatch({
      type: get_one_channal,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one city data
export const UpdateOneChannalData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/channal/${id}`, body);

    dispatch({
      type: update_one_channal,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
